import React, { useEffect, useState } from "react";
import connect from "react-redux/lib/connect/connect";
import { isEmpty } from "../../common/cores";
import store from "../../common/store";
import language from "../../utils/language.json";
import setLanguageToHeader from "../../common/cores/setLanguageToHeader";
import { initSocket } from "../../common/cores/socket";

const langKinds = [
  {
    lang: "日本語",
    src: "/images/flags/jp.png",
  },

  {
    lang: "English",
    src: "/images/flags/en.png",
  },

  {
    lang: "한국어",
    src: "/images/flags/ko.png",
  },
  {
    lang: "中国语",
    src: "/images/flags/cn.png",
  },

  // {
  //     lang: "แบบไทย"
  // },
  // {
  //     lang: "Filipino"
  // },
  // {
  //     lang: "Tiếng Việt"
  // },
  // {
  //     lang: "Français"
  // },
  // {
  //     lang: "Español"
  // },
  // {
  //     lang: "Filipino"
  // },
  // {
  //     lang: "عربى"
  // },
  // {
  //     lang: "हिन्दी"
  // },
  // {
  //     lang: "Türkçe"
  // },
  // {
  //     lang: "فارسی"
  // },
  // {
  //     lang: "Português"
  // },
  // {
  //     lang: "Руccкий"
  // },
  // {
  //     lang: "Deutsch"
  // },
  // {
  //     lang: "ภาษาไทย"
  // },
  // {
  //     lang: "Suomi"
  // },
  // {
  //     lang: "Polski"
  // },
  // {
  //     lang: "Italiano"
  // },
  // {
  //     lang: "မြန်မာ"
  // },
  // {
  //     lang: "اردو"
  // },
  // {
  //     lang: "Українська"
  // },
  // {
  //     lang: "Melayu"
  // },
  // {
  //     lang: "বাংলা"
  // },
  // {
  //     lang: "Marathi"
  // },
  // {
  //     lang: "Tamil"
  // },
  // {
  //     lang: "Telugu"
  // },
];
const LanguageSelection = ({ langSelec, onLanguage }) => {
  const [showMenus, setShowMenus] = useState(false);

  const onClose = () => {
    onLanguage();
  };

  const getSrcByLang = (lang) => {
    const found = langKinds.find((item) => item.lang === lang);
    return found ? found.src : null;
  };

  const changeLanguage = (val) => {
    window.lang = language[val];
    window.language = val;
    localStorage.setItem("language", val);
    setLanguageToHeader(localStorage.getItem("language"));
    initSocket(localStorage.getItem("language"));
    store.dispatch({
      type: "change_language",
      payload: val,
    });

    onClickShowMenu(false);
  };

  const onClickShowMenu = () => {
    setShowMenus(!showMenus);
  };

  return (
    <div className="select_lang_flag">
      <div className="selected_flag" onClick={(e) => onClickShowMenu()}>
        <img
          src={getSrcByLang(localStorage.getItem("language"))}
          id="selected_lang_flag"
          className="header_lang_flag"
        />
        <span className="language-name" langkey="common.lang.ko">
          {localStorage.getItem("language")}
        </span>
      </div>
      <ul
        style={{
          display: showMenus ? "flex" : "none",
          flexDirection: "column",
          position: "absolute",
          width: "150px",
        }}
      >
        {langKinds.map((kind, index) => {
          return (
            <li
              onClick={() => changeLanguage(kind.lang)}
              key={index}
              style={{ justifyContent: "space-evenly", fontSize: "12px" }}
            >
              <img src={kind.src} className="header_lang_flag" data-val="ko" />
              <span
                className="header_lang_flag"
                data-val="ko"
                langkey="common.lang.ko"
              >
                {kind.lang}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
const mapState = (state) => ({
  language: state.more.language,
});
export default connect(mapState, {})(LanguageSelection);



// WEBPACK FOOTER //
// ./src/components/Layout/LanguageSelection.js